<template>
    <v-container fluid class="px-4" v-if="event">
        <v-row>
            <v-col cols="12">
                <div
                    class="subtitle-2 pb-2 font-weight-bold"
                    v-html="$t('eventList.eventDetails.name')"/>
                <v-combobox
                    outlined
                    hide-details
                    height="40px"
                    append-icon="expand_more"
                    autocomplete="off"
                    v-model="event.customer"
                    :placeholder="$t('placeholder.customerGroupSelect')"
                    :items="customerGroupList"/>
            </v-col>
            <v-col cols="12">
                <div
                    class="subtitle-2 pb-2 font-weight-bold"
                    v-html="$t('eventList.eventDetails.startDate')"/>
                <date-field
                    v-model="event.startDate"/>
            </v-col>

            <v-col cols="6">
                <div
                    class="subtitle-2 pb-2 font-weight-bold"
                    v-html="$t('eventList.eventDetails.participantAmount')"/>
                <v-text-field
                    outlined
                    hide-details
                    height="40px"
                    type="number"
                    v-model="event.participantAmount"/>
            </v-col>
            <v-col cols="6">
                <div
                    class="subtitle-2 pb-2 font-weight-bold"
                    v-html="$t('eventList.eventDetails.teamAmount')"/>
                <v-text-field
                    outlined
                    hide-details
                    height="40px"
                    type="number"
                    v-model="event.teamAmount"/>
            </v-col>
            <v-col cols="12">
                <div
                    class="subtitle-2 pb-2 font-weight-bold"
                    v-html="$t('eventList.eventDetails.teamType')"/>

                <v-btn-toggle
                    mandatory
                    active-class="teamtype--active"
                    class="team-type-button-group"
                    v-model="teamType">
                    <v-btn
                        block
                        height="40px">
                        {{ teamTypeMapDict[0].text }}
                    </v-btn>
                    <v-btn
                        block
                        height="40px">
                        {{ teamTypeMapDict[1].text }}
                    </v-btn>
                </v-btn-toggle>
            </v-col>
            <v-col cols="12">
                <div
                    class="subtitle-2 pb-2 font-weight-bold"
                    v-html="$t('eventList.eventDetails.status')"/>
                <v-switch
                    hide-details
                    inset
                    v-model="status"
                    class="mt-0"
                    color="primary"/>
            </v-col>

            <v-col cols="12" v-if="!createMode">
                <v-card-actions class="pa-0">
                    <div
                        :style="{
                            width: '140px'
                        }"
                        class="subtitle-1 pb-2 font-weight-bold"
                        v-html="$t('eventList.eventDetails.details')"/>
                    <hr class="full-width ma-4">
                </v-card-actions>
                <div v-html="`<b>Latest Updatee</b>: ${$util.getDDMMYYYYDateFormat(event.lastUpdateDate)} &ensp; &ensp; by: <b>${event.updatedBy}</b>`"/>
            </v-col>
        </v-row>
    </v-container>
    <div v-else></div>
</template>

<script>
import DateField from '@/components/fields/DateField'

export default {
    name: 'EventDetailsView',

    components: {
        DateField
    },

    props: {
        event: {
            type: Object,
            default: () => null
        },

        createMode: {
            type: Boolean,
            default: false
        }
    },

    data () {
        return {
            customerGroupList: [
                'Pi R Sqaure',
                'Pi R',
                'Proud Group',
                'Andamanda'
            ],

            teamTypeMapDict: {
                0: {
                    text: 'Random',
                    value: 'random'
                },
                1: {
                    text: 'Custom',
                    value: 'custom'
                }
            },

            statusMapDict: {
                active: true,
                inactive: false
            }
        }
    },

    computed: {
        teamType: {
            get () {
                const matchIndex = Object.keys(this.teamTypeMapDict).find(key => this.teamTypeMapDict[key]?.value === this.event.teamType)
                return matchIndex ? parseInt(matchIndex) : null
            },

            set (value) {
                this.event.teamType = this.teamTypeMapDict?.[value]?.value
            }
        },

        status: {
            get () {
                return this.statusMapDict[this.event.status]
            },

            set (value) {
                this.event.status = Object.entries(this.statusMapDict).find(item => item[1] === value)?.[0]
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.team-type-button-group {
    width: 50%;
}

.teamtype--active {
    background-color: #08979C !important;
    color: white !important;
}
</style>
